var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconServiceProviders = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.6667 33.3333V6.66667C26.6667 5.78261 26.3155 4.93477 25.6904 4.30964C25.0652 3.68452 24.2174 3.33333 23.3333 3.33333H16.6667C15.7826 3.33333 14.9348 3.68452 14.3096 4.30964C13.6845 4.93477 13.3333 5.78261 13.3333 6.66667V33.3333",
    stroke: "#9810FA",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.3333 10H6.66667C4.82572 10 3.33333 11.4924 3.33333 13.3333V30C3.33333 31.8409 4.82572 33.3333 6.66667 33.3333H33.3333C35.1743 33.3333 36.6667 31.8409 36.6667 30V13.3333C36.6667 11.4924 35.1743 10 33.3333 10Z",
    stroke: "#9810FA",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconServiceProviders);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-service-providers.109e298e3d14bf6f106d64c9e38f06a6.svg";